import { render } from "./TicketStatus.vue?vue&type=template&id=36508afa&scoped=true&ts=true"
import script from "./TicketStatus.ts?vue&type=script&lang=ts"
export * from "./TicketStatus.ts?vue&type=script&lang=ts"

import "./TicketStatus.vue?vue&type=style&index=0&id=36508afa&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36508afa"]])

export default __exports__